import { ProposalGeneralInfo } from '@/types/management.types'
import React from 'react'

interface GeneralDataProps {
  generalInfo: ProposalGeneralInfo | undefined
}

const GeneralData: React.FC<GeneralDataProps> = ({
  generalInfo = {
    fecha: '22/Mayo/2025',
    nombreCliente: 'Empresa ABC',
    atencionA: 'Manuel Fernández',
    tipoDeActivo: 'Utilitario',
    numeroCotizaciones: 3,
  },
}) => {
  const { fecha, nombreCliente, atencionA, tipoDeActivo, numeroCotizaciones } =
    generalInfo || {}
  return (
    <div className="w-full bg-white rounded-lg  ">
      {/* Header */}
      <div className="bg-[#E4EFFF] px-6 py-3 ">
        <h2 className="text-sm font-semibold text-[#000000] uppercase tracking-wide text-center">
          DATOS GENERALES
        </h2>
      </div>

      {/* Content Table */}
      <div className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Left Column */}
          <div className="space-y-4">
            <div className="flex flex-col sm:flex-row">
              <span className="text-sm font-medium text-gray-900 mb-1 sm:mb-0 w-1/2">
                Fecha
              </span>
              <span className="text-sm  text-gray-600 font-medium">
                {fecha}
              </span>
            </div>

            <div className="flex flex-col sm:flex-row sm:justify-between">
              <span className="text-sm font-medium text-gray-900 mb-1 sm:mb-0 ">
                Nombre cliente
              </span>
              <span className="text-sm text-gray-600 font-medium w-1/2">
                {nombreCliente}
              </span>
            </div>

            <div className="flex flex-col sm:flex-row sm:justify-between">
              <span className="text-sm font-medium text-gray-900 mb-1 sm:mb-0">
                Atención a
              </span>
              <span className="text-sm text-gray-600 font-medium w-1/2">
                {atencionA}
              </span>
            </div>
          </div>

          {/* Right Column */}
          <div className="space-y-4">
            <div className="flex flex-col sm:flex-row sm:justify-between">
              <span className="text-sm font-medium text-gray-900 mb-1 sm:mb-0">
                Tipo de activo
              </span>
              <span className="text-sm text-gray-600 font-medium w-1/2">
                {tipoDeActivo}
              </span>
            </div>

            <div className="flex flex-col sm:flex-row sm:justify-between">
              <span className="text-sm font-medium text-gray-900 mb-1 sm:mb-0">
                No. de cotizaciones
              </span>
              <span className="text-sm text-gray-600 font-medium w-1/2">
                {numeroCotizaciones}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GeneralData
